import React, { useEffect } from "react";

export default function Xendit(props) {
  const alert = props.alert;
  const setIsLoading = props.setIsLoading;
  const decodedString = atob(decodeURIComponent(props.token));
  const searchParams = new URLSearchParams(decodedString);
  const token = searchParams.get("token");
  const amount = searchParams.get("amount");
  const orderId = searchParams.get("tranId");
  const publicKey = searchParams.get("authToken");
  const currency = searchParams.get("currencyISO");

  useEffect(() => {
    if (publicKey) {
      const script = document.createElement("script");
      script.src = "https://js.xendit.co/v1b/xendit.min.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        window.Xendit.setPublishableKey(publicKey);
        window.Xendit.card.createAuthentication(
          {
            amount: amount,
            token_id: token,
            currency: currency,
            external_id: orderId,
          },
          (err, resp) => {
            console.log("Authentication", resp, err);
            if (err) {
              if (err.message) {
                alert(err.message);
              } else {
                alert("An error occurred while processing the payment.");
              }
            } else {
              window.location.href = resp.payer_authentication_url;
            }
          }
        );
        setIsLoading(false);
      };
      return () => {
        document.body.removeChild(script);
      };
    } else {
      alert("Payment gateway have not step up!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, orderId, setIsLoading, token, publicKey]);

  return <div></div>;
}
